export default function() {
	const cards = document.querySelectorAll('.linked-card');  
	// console.log('cards', cards);
	if (!cards) return;
	Array.prototype.forEach.call(cards, card => {
			const link = card.querySelector('a');
			if (!link) return;
			// duplicated node
			const clone = link.cloneNode(true);
			clone.style.position = 'absolute';
			clone.setAttribute('aria-hidden', 'true');
			clone.setAttribute('tabindex', '-1');
			clone.classList.add('linked-card__link--hidden');
			clone.classList.remove('button');
			card.appendChild(clone);
	});
}